export const selectRegistration = state => state.registration;
